(function(){

    const ACTION = {
        get ADD_TO_CART() {
            /**
             * 加入購物車
             * data 內容需包含
             * {
             *   id : String  // type 為 ONLINE 的 SalesPlan id
             * }
             */
            return "ADD_TO_CART"
        },
        get ADD_GROUP_TO_CART() {
            /**
             * 加入購物車
             * data 內容需包含
             * {
             *   ids : [String, String, String]  // type 為 ONLINE 的 SalesPlan id
             * }
             */
            return "ADD_GROUP_TO_CART"
        },
        get REMOVE_FROM_CART() {
            /**
             * 從購物車中移除
             * data 內容需包含
             * {
             *   id : String  // type 為 ONLINE 的 SalesPlan id
             * }
             */
            return "REMOVE_FROM_CART"
        },
        get REMOVE_ALL_FROM_CART() {
            /**
             * 從購物車中清空
             */
            return "REMOVE_ALL_FROM_CART"
        },
        get REFRESH_CART_VIEW() {
            /**
             * 更新購物車view
             */
            return "REFRESH_CART_VIEW"
        },
        get REFRESH_USER_INFO() {
            /**
             * 更新nav使用者資訊
             */
            return "REFRESH_USER_INFO"
        },
        get FAKE_ADD_TO_CART() {
            /**
             * 假的加入購物車
             * 組合產品模擬使用者選購時使用, 並未真實的加入購物車, 點選結帳時再加入
             * data 內容需包含
             * {
             *   id : String  // type 為 ONLINE 的 SalesPlan id
             * }
             */
            return "FAKE_ADD_TO_CART"
        },
        get FAKE_REMOVE_FROM_CART() {
            /**
             * 假的從購物車中移除
             *  組合產品模擬使用者選購時使用, 並未真實的移除購物車
             * data 內容需包含
             * {
             *   id : String  // type 為 ONLINE 的 SalesPlan id
             * }
             */
            return "FAKE_REMOVE_FROM_CART"
        }
    }

    var eventQueue = [];
    var registerAction = [];
    var isProcessAction = false;
    var actionMap = new Map();
    const registerMessage = async (actionName, action) => {
        if(registerAction.indexOf(actionName) === -1){
            registerAction.push(actionName)
        }
        window.addEventListener("message", (e) => {
            if(e.origin === `${window.location.protocol}//${window.location.hostname}`){
                if(registerAction.indexOf(e.data.action) !== -1 && e.data.action === actionName) {
                    eventQueue.push(e.data);
                }
                if(e.data.action === actionName){
                    actionMap.set(actionName, action)
                    processAction();
                }
            }
        });
    };

    const processAction = async () => {
        if(isProcessAction){
            return;
        }
        let redirect = null;
        while (eventQueue.length > 0){
            if(!isProcessAction){
                let current = eventQueue[0]
                if(current.redirect){
                    redirect = current.redirect;
                }
                let action = actionMap.get(current.action);
                isProcessAction = true;
                await Promise.resolve(action(current.data)).then(async function (){
                    await eventQueue.shift();
                    isProcessAction = false;
                })
            }
        }
        if(redirect){
            if (window.ga && redirect.indexOf("/shop/cart.html") !== -1) {
                window.ga('send', 'event', 'InitiateCheckout', 'checkout', 'processButton');
            }
            if (window.fb && redirect.indexOf("/shop/cart.html") !== -1) {
                window.fb('InitiateCheckout', null);
            }
            window.location.href = redirect;
        }
        isProcessAction = false;
    }

    const sendMessage = async (message) => {
        if(!message || !message.action || !message.data){
            console.error("invalidate data format:", message)
            return;
        }
        window.postMessage(message, "/");
    };

    if(window.eHanlin === undefined || window.eHanlin === null){
        window.eHanlin = {}
    }
    
    if(window.eHanlin.platform_message === undefined || window.eHanlin.platform_message === null){
        window.eHanlin.platform_message = {
            get ACTION() {
                return ACTION;
            },
            registerMessage: (actionName, action) => registerMessage(actionName, action),
            sendMessage: (actionName, data) => sendMessage(actionName, data)
        }
    }    

})();